// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 739 ? "curated-trails" : chunkId) + "." + {"393":"feda886d","447":"d3fc43fc","739":"fb6bf9d1","967":"3401ab37"}[chunkId] + ".chunk.js";
};